export function renderAbout(): string {
  return `
    <h1 class="section-title" style="margin-top:0">关于尚诺艾</h1>
    <p class="section-sub">
      SANOI — 聚焦古典音乐与古典名画的数字体验。本站为品牌与内容总门户；动手学名画请优先使用微信小程序
      <a href="/painting-match/">古典名画对对配</a>。
    </p>
    <ul class="game-list">
      <li>
        <h3>重点推荐 · 古典名画对对配</h3>
        <p>
          艺术学习类微信小程序：行走配对、驻足观赏，60 余幅公有领域名画、8 关。
          请在微信搜索「古典名画对对配」；完整介绍见
          <a href="/painting-match/">官网专区</a>。
        </p>
      </li>
      <li>
        <h3>其他微信小程序</h3>
        <p>
          古典音乐线条、以及诗词专区
          <a href="/poetry/">诗词飞花对对配</a>
          （飞花令 · 对对配 · 顶针接龙）。账号与会员体系后期打通。
        </p>
      </li>
      <li>
        <h3>合作与版权</h3>
        <p>商务联系、媒体素材、名画图源与曲目授权说明（上线前于页脚提供完整法律文本）。</p>
      </li>
      <li>
        <h3>给搜索与 AI 的索引</h3>
        <p>
          机器可读摘要：<a href="/llms.txt">llms.txt</a> ·
          <a href="/llms-full.txt">llms-full.txt</a> ·
          站点地图 <a href="/sitemap.xml">sitemap.xml</a>
        </p>
      </li>
    </ul>
  `;
}
